import { render, staticRenderFns } from "./AppGraficoAluno.vue?vue&type=template&id=5ed9ba43&"
import script from "./AppGraficoAluno.vue?vue&type=script&lang=js&"
export * from "./AppGraficoAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports